import { Menu, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface IProps {
	children: any;
	renderElement(el: any, index: number, selectedId: number, rowId: number): any;
	data: any[];
	search?: any;
	setSearch?(value: any): any;
	selectedId?: number;
	hideSearch?: boolean;
	item: any;
	renderRecommended?(item: any): any;
	getRecommended?(item: any, setter: any): any;
	recommended?: any;
}

const EditMenu = (props: IProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const [rec, setRec] = useState<any>();
	const [recomendadetCandidate, setRecomendadetCandidate] = useState<
		any | null
	>(null);

	useEffect(() => {
		if (props.getRecommended)
			props.getRecommended(props.item, setRecomendadetCandidate);
	}, [props.item]);

	useEffect(() => {
		if (props.renderRecommended)
			setRec(props.renderRecommended(recomendadetCandidate));
	}, [props.renderRecommended]);

	return (
		<div>
			<div
				className="cursor-pointer"
				onClick={(event) => {
					setAnchorEl(event.currentTarget);
				}}
			>
				{props.children}
			</div>
			<Menu
				open={anchorEl ? true : false}
				anchorEl={anchorEl}
				onClose={() => {
					setAnchorEl(null);
				}}
				variant={"menu"}
				className="overflow-visible"
				sx={{ overflowX: "unset", overflowY: "unset" }}
			>
				<div className="flex flex-col gap-3 px-3 py-4">
					{!props.hideSearch ? (
						<TextField
							label="Поиск"
							value={props.search}
							onChange={(ev) => {
								if (props.setSearch) props.setSearch(ev.target.value);
							}}
						></TextField>
					) : null}
					{props.renderRecommended
						? props.renderRecommended(recomendadetCandidate)
						: null}
					{props.data.map((d, i) =>
						props.renderElement(d, i, props.selectedId || 0, props.item.id)
					)}
				</div>
			</Menu>
		</div>
	);
};

export default EditMenu;
